import React from "react";
import { useIsDesktop } from "@/hooks/useMediaQuery";
import { PriceAlertConfigPageDesktop } from "./PriceAlertConfigPage.Desktop";
import { PriceAlertConfigPageMobile } from "./PriceAlertConfigPage.Mobile";

export const PriceAlertConfigPage: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <PriceAlertConfigPageDesktop />;
  }

  return <PriceAlertConfigPageMobile />;
};
